<template>
  <article :class="{ 'page-container full-width shop-list-container': true }">
    <div class="filter-container">
      <div class="buy-card-link-container">
        <a
            class="btn-buy-card btn-with-icon"
            :href="this.$store.state.season == 'winter' ? 'https://card-webshop.feratel.com/kcs01/winter/index.jsp?language=de&mode=mycard#p:mycard-login' : 'https://card-webshop.feratel.com/kcs01/default/index.jsp?language=de&mode=mycard#p:mycard-login'"
            target="_blank"
            rel="nofollow noopener"
        >{{ $t("seasonCard_refill") }} <img src="@/assets/svgs/2024/icons/arrow-big.svg" alt="ok"></a
        >
      </div>
      <div class="buy-card-link-container">
        <a
            class="btn-buy-card btn-with-icon"
            href="https://card-webshop.feratel.com/kcs01/web003/index.jsp"
            target="_blank"
            rel="nofollow noopener"
        >{{ $t("seasonCard_buy_new") }} <img src="@/assets/svgs/2024/icons/arrow-big.svg"></a
        >
      </div>
      <div class="buy-card-link-container">
        <a
            class="btn-buy-card btn-with-icon"
            :href="shopLink"
            target="_blank"
            rel="nofollow noopener"
        >{{ $t("printAtHome") }} <img src="@/assets/svgs/2024/icons/arrow-big.svg"></a
        >
      </div>

      <div class="input-group search-group">
        <input class="input-group-field search-input" :placeholder="$t('filterLabels.searchPlaceholder')" type="text" v-model="searchText" @keyup="doSearch">
        <div class="input-group-button">
          <font-awesome-icon :icon="['far', 'search']"/>
        </div>
      </div>

      <div class="entity-switches">
        <button
            type="button"
            :class="{
            'button btn-entity-switch': true,
            selected: selectedEntities === 'week-cards',
          }"
            @click="selectEntity('week-cards')"
        >
          {{ $t("shopList.weekCard") }}
        </button>
        <button
            type="button"
            :class="{
            'button btn-entity-switch': true,
            selected: selectedEntities === 'season-cards',
          }"
            @click="selectEntity('season-cards')"
        >
          {{ $t("shopList.seasonCard") }}
        </button>
      </div>

      <div class="entity-switches" v-if="selectedEntities === 'season-cards'">
        <button
            type="button"
            :class="{
            'button btn-entity-switch': true,
            selected: selectedSeasonEntity === 'delivery-points',
          }"
            @click="selectSeasonEntity('delivery-points')"
        >
          {{ $t("shopList.deliveryOffice") }}
        </button>
        <button
            type="button"
            :class="{
            'button btn-entity-switch': true,
            selected: selectedSeasonEntity === 'charging-points',
          }"
            @click="selectSeasonEntity('charging-points')"
        >
          {{ $t("shopList.chargingOffice") }}
        </button>
      </div>

      <div class="sort-and-more-filter-container">

        <div class="sort-group">
          <select class="category-select" v-model="sortedBy">
            <option value="" disabled="true">{{ $t("sortAfter") }}</option>
            <option value="alphabetical-asc">{{ $t("sorting.asc") }}</option>
            <option value="alphabetical-desc">{{ $t("sorting.desc") }}</option>
            <option value="distance">{{ $t("sorting.distance") }}</option>
          </select>
        </div>

        <button type="button" :class="{'button btn-filter': true, 'active-filter': isResultFiltered}" @click="openFilterReveal">
          {{ $t('filterLabels.moreFilters') }}
          <img src="@/assets/svgs/2024/icons/filter.svg" alt="filter" v-if="!isResultFiltered">
          <img src="@/assets/svgs/2024/icons/filter-white.svg" alt="filter-white" v-if="isResultFiltered">
        </button>

        <map-button/>

      </div>
    </div>

    <ul v-if="isLoading" style="list-style: none">
      <li style="width: 90%">
        <vcl-facebook></vcl-facebook>
      </li>
      <li style="width: 90%">
        <vcl-facebook></vcl-facebook>
      </li>
      <li style="width: 90%">
        <vcl-facebook></vcl-facebook>
      </li>
      <li style="width: 90%">
        <vcl-facebook></vcl-facebook>
      </li>
    </ul>

    <ul
        class="companies-list week-card-salespoints"
        v-show="results.length > 0"
    >
      <shop-item
          :item="company"
          v-for="company in results"
          :key="`salespoint-${company.id}`"
          :entity="selectedEntities"
      />
    </ul>

    <div class="no-entities label" v-if="false">
      {{ $t("nothingFound") }}
    </div>

    <filter-overlay
        :key="`filter-reveal-${filterEntities}`"
        ref="shopListFilterReveal"
        :entities="filterEntities"
        v-on:close-reveal="closeFilterReveal"
        enable-range
    />
  </article>
</template>

<script>
import foundation from "@/mixins/foundation";
import checkforupdates from "@/mixins/checkforupdates.js";
import {
  mapActions as mapSearchActions,
  mapGetters as mapSearchGetters,
  getterTypes,
  actionTypes,
} from "vuex-search";
import {VclFacebook} from "vue-content-loading";
import MapButton from "@/components/MapButton.vue";

export default {
  name: "ShopList",
  components: {
    MapButton,
    ShopItem: () => import("@/components/lists/ShopItem.vue"),
    FilterOverlay: () => import("@/components/FilterOverlay.vue"),
    VclFacebook,
  },
  mixins: [foundation, checkforupdates],
  data() {
    return {
      isLoading: true,
      selectedEntities: "week-cards",
      selectedSeasonEntity: "delivery-points",
      searchText: "",
      sortedBy: "distance",
      results: [],
      filterEntities: "salespoints",
    };
  },
  metaInfo() {
    return {
      title: this.$t("buyCard") + " | " + "Kärnten Card App",
      meta: [
        {
          property: "og:title",
          content: this.$t("buyCard") + " | " + "Kärnten Card App",
        },
        {
          property: "og:site_name",
          content: "Kärnten Card App",
        },
        {
          property: "og:url",
          content: window.location.href,
        },
        {
          property: "og:image",
          content: "https://app.kaerntencard.at/img/kc-logo.png",
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    };
  },
  computed: {
    ...mapSearchGetters("salespoints", {
      salespointsResultIds: getterTypes.result,
      isSearchingSalespoints: getterTypes.isSearching,
    }),
    selectedRange() {
      return this.$store.getters.getSelectedRange(this.filterEntities);
    },
    salespointCount() {
      return this.results.length;
    },
    shopLink() {
      if (this.selectedEntities == "week-cards") {
        return this.$store.state.shopLink[this.$store.state.season]
            .weekCardLink;
      } else {
        return this.$store.state.shopLink[this.$store.state.season]
            .seasonCardLink;
      }
      // return link = (this.$store.state.season === "sommer") ? 'https://card.feratel.com/cardwebshop2/kcs01/web002' : 'https://card.feratel.com/cardwebshop2/kcs01/winter002'
    },
    isResultFiltered() {
      if (this.selectedRange <= 140) {
        return true;
      }

      return false;
    },
  },
  created() {
    this.initView();
  },
  methods: {
    ...mapSearchActions("salespoints", {
      searchSalespoints: actionTypes.search,
    }),
    initView() {
      this.requestCurrentPosition()
          .then((pos) => {
            this.$store.dispatch("updateCurrentPosition", pos);
            this.$store.dispatch("fetchNearbySalespoints", {
              lang: this.$store.state.language,
              season: this.$store.state.season,
              coords: this.$store.state.currentPosition,
            });
          })
          .catch((err) => {
            console.error(err);
            if (
                this.$store.state.currentPosition.lat !== undefined &&
                this.$store.state.currentPosition.lng !== undefined
            ) {
              this.$store.dispatch("fetchNearbySalespoints", {
                lang: this.$store.state.language,
                season: this.$store.state.season,
                coords: this.$store.state.currentPosition,
              });
            } else {
              this.$store
                  .dispatch("fetchSalespoints", {
                    lang: this.$i18n.locale,
                    season: this.$store.state.season,
                  })
                  .then(() => {
                    this.sortedBy = "";
                  });
            }
          });
      this.$store.dispatch("fetchCategories", {
        lang: this.$store.state.lang,
        season: this.$store.state.season,
      });
      this.$store.dispatch("fetchCriterias", {
        lang: this.$store.state.lang,
        season: this.$store.state.season,
      });
    },
    searchAndFilterResults() {
      let points = [];
      console.log("start loading salespoints");

      // check entities
      if (this.selectedEntities === "week-cards") {
        this.salespointsResultIds.forEach((id) => {
          let salespoint = this.$store.getters.getSalespointByID(id);
          let salespointTypes = Object.values(salespoint.type);

          if (salespointTypes.includes("Verkaufsstelle")) {
            points.push(salespoint);
          }
        });
      }

      if (this.selectedEntities === "season-cards") {
        // check season entities
        if (this.selectedSeasonEntity === "delivery-points") {
          this.salespointsResultIds.forEach((id) => {
            let salespoint = this.$store.getters.getSalespointByID(id);
            let salespointTypes = Object.values(salespoint.type);

            if (salespointTypes && salespointTypes.includes("Ausgabestelle")) {
              points.push(salespoint);
            }
          });
        } else if (this.selectedSeasonEntity === "charging-points") {
          this.salespointsResultIds.forEach((id) => {
            let salespoint = this.$store.getters.getSalespointByID(id);
            let salespointTypes = Object.values(salespoint.type);

            if (salespointTypes && salespointTypes.includes("Aufladestelle")) {
              points.push(salespoint);
            }
          });
        }
      }
      console.log("loaded salespoints", points.length);

      // filter for current range if companies have distance set
      if (this.selectedRange <= 140 && points.length >= 1) {
        points = points.filter((sp) => {
          if (sp.distance !== undefined) {
            return sp.distance <= this.selectedRange * 1000;
          }
        });
      }

      // filter for language
      /* console.log("----", this.$i18n.locale, points); */
      if (this.$i18n.locale && points.length >= 1) {
        points = points.filter(
            (sp) => sp.language && this.$i18n.locale == sp.language
        );
      }

      this.results = this.sortResult(points);
      this.isLoading = false;
    },
    openFilterReveal() {
      this.$refs.shopListFilterReveal.$el.classList.add("is-reveal-open");
    },
    closeFilterReveal() {
      this.$refs.shopListFilterReveal.$el.classList.remove("is-reveal-open");
    },
    selectEntity(newEntity) {
      this.selectedEntities = newEntity;
    },
    selectSeasonEntity(newEntity) {
      this.selectedSeasonEntity = newEntity;
    },
    doSearch() {
      this.searchSalespoints(this.searchText);
    },
    sortResult(result) {
      if (this.sortedBy === "") {
        return result;
      }

      if (this.sortedBy === "alphabetical-asc") {
        return result.sort((a, b) => {
          if (a.title < b.title) {
            return -1;
          }

          if (a.title > b.title) {
            return 1;
          }

          return 0;
        });
      }

      if (this.sortedBy === "alphabetical-desc") {
        return result.sort((a, b) => {
          if (a.title > b.title) {
            return -1;
          }

          if (a.title < b.title) {
            return 1;
          }

          return 0;
        });
      }

      if (this.sortedBy === "distance") {
        return result.sort((a, b) => {
          if (a.distance < b.distance) {
            return -1;
          }

          if (a.distance > b.distance) {
            return 1;
          }

          return 0;
        });
      }

      // always return the filter/search/sort result if no sorting happenes
      return result;
    },
  },
  watch: {
    salespointsResultIds: function() {
      this.searchAndFilterResults();
    },
    selectedEntities: function() {
      this.searchAndFilterResults();

      this.$store.dispatch("updateSalesEntity", this.selectedEntities);
    },
    selectedSeasonEntity: function() {
      this.searchAndFilterResults();

      this.$store.dispatch("updateSeasonEntity", this.selectedSeasonEntity);
    },
    sortedBy: function() {
      this.searchAndFilterResults();
    },
    selectedRange: function() {
      this.searchAndFilterResults();
    },
    "$store.state.season": function() {
      this.initView();
      this.searchAndFilterResults();
      this.$store
          .dispatch("fetchCardInfos", {
            lang: this.$store.state.language,
            season: this.$store.state.season,
          })
          .then(() => {
            this.$store.dispatch("fetchNews", {
              lang: this.$store.state.language,
              season: this.$store.state.season,
            });
          })
          .catch((err) => console.log(err));
    },
    "$store.state.language": function() {
      this.initView();
      this.searchAndFilterResults();
      this.$store
          .dispatch("fetchCardInfos", {
            lang: this.$store.state.language,
            season: this.$store.state.season,
          })
          .then(() => {
            this.$store.dispatch("fetchNews", {
              lang: this.$store.state.language,
              season: this.$store.state.season,
            });
          })
          .catch((err) => console.log(err));
    },
    results: {
      handler: function(t) {
        // console.log('results', t)
        this.results = t;
        this.isLoading = false;
        this.$store.dispatch("updateFilteredResultsCount", {
          entity: this.filterEntities,
          count: this.results.length,
        });
        this.$store.dispatch("updateFilteredResults", {
          entity: this.filterEntities,
          results: this.results,
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.selectedEntities = this.$store.state.lastSalesEntity;
    this.selectedSeasonEntity = this.$store.state.lastSeasonEntity;
  },
};
</script>

<style lang="scss" scoped>

.map-button-wrapper {
  margin-top: 2rem;
}


.shop-list-container {
  .filter-container {
    margin-top: 2rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;

    background-color: white;
    /*box-shadow: 0px 0px 2px rgba($black, .15);*/

    input,
    select,
    button,
    .button {
      background-color: $light-gray;
      border-radius: 50px;
      font-weight: bold;
      border: 1px solid $medium-gray;
      color: $dark-gray;
      margin: 0;
      font-size: 0.9rem;

      img {
        height: rem-calc(21);
        width: auto;
        margin-left: 0.3rem;
      }
    }

    button,
    .button,
    select {
      height: rem-calc(48px);
    }

    button, a.button {
      &:hover {
        background-color: white;
      }
    }

    .search-group {
      margin-top: 1rem;
      .search-input {
        height: 60px;
        padding: 1rem;
        box-shadow: none;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        font-weight: normal;
        max-width: 500px;
        margin-bottom: 1rem;

        &::placeholder {
          color: $dark-gray;
          opacity: 1; /* Firefox */
        }

        &::-ms-input-placeholder { /* Edge 12 -18 */
          color: $dark-gray;
        }
      }
      .input-group-button {
        background-color: $dark-gray;
        font-size: 1.75rem;
        color: white;
        border-top-right-radius: 50px;
        border-bottom-right-radius: 50px;
        width: 67px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: rem-calc(10);
      }
    }

    .entity-switches {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 2px;

      .btn-entity-switch {
        &:not(:first-child) {
          margin-left: rem-calc(10);
        }
        &.selected {
          color: white;
          background-color: $dark-gray;
          border-color: $dark-gray;
        }
      }
    }
    .sort-and-more-filter-container {
      display: flex;
      margin-bottom: .5rem;
      flex-wrap: wrap;


      .sort-group {
        margin-top: rem-calc(10);
        margin-right: rem-calc(10);

        .category-select {
          margin: 0;
          padding: .5rem 1rem;
          padding-right: 2rem;
          color: $dark-gray;
          border-radius: 20rem;
          align-items: flex-end;
        }
      }

      .btn-filter {
        margin-top: rem-calc(10);
        &.active-filter {
          color: $white;
          background-color: $dark-gray;
          border: 1px solid $dark-gray;
        }
      }
    }

    .buy-card-link-container:first-of-type {
      padding-top: 0.75rem;
    }

    .buy-card-link-container {
      //@include xy-gutters($gutter-type: padding, $gutter-position: left right);
      text-align: center;
      padding-bottom: 0.75rem;

      @media print, screen and (min-width: 40em) {
        padding-bottom: 0.75rem;
      }

      .btn-buy-card {
        width: 400px;
        max-width: 100%;
      }
    }
  }

  .companies-list {
    @include xy-grid();
    @include xy-grid-layout(1, ".shop-item", false, 0);
    list-style: none;
    margin: 0;
    padding: 0;

    @include breakpoint(medium) {
      @include xy-grid-layout(2, ".shop-item");
    }

    @include breakpoint(large) {
      @include xy-grid-layout(2, ".shop-item");
    }
  }

  .no-entities {
    display: block;
    width: 100%;
    max-width: rem-calc(350);
    margin: 0 auto;
    margin-top: 1rem;
    padding: 0.75rem 1.5rem !important;
    font-size: 1.15rem;
    text-align: center;
    border-radius: 20rem;
  }
}
</style>
